import React from 'react'
import { useParams } from 'react-router';
import Pagination from '../Pagination/Pagination';

const PostDy = () => {
    const { number } = useParams(); // Get page number from URL

    return (
        <div>
            <h1>Page {number}</h1>
            <p>This is content for page {number}.</p>
            <Pagination/>
        </div>
    );
  
}

export default PostDy
